import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import { paths } from '@src/routes/paths';

import { FeatureFlag } from 'src/auth/feature-flags';
import FeatureFlagGuard from 'src/auth/guard/feature-flag-guard';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('../pages/CompanyProjectActionIndexPage'));
const CreatePage = lazy(() => import('../pages/CompanyProjectActionCreatePage'));
const EditPage = lazy(() => import('../pages/CompanyProjectActionEditPage'));

// ----------------------------------------------------------------------
// Auth/Onboarding/DashboardLayout/Suspense are provided once by the shared
// dashboard shell (routes/pages/dashboard) — this only adds this domain's
// own feature flag check on top of it.
export const companyProjectActionRoutes = [
  {
    path: paths.dashboard.company_project_action.index.replace('/dashboard/', ''),
    element: (
      <FeatureFlagGuard flag={FeatureFlag.CompanyProjectActions}>
        <Outlet />
      </FeatureFlagGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'create', element: <CreatePage /> },
      { path: 'edit/:id', element: <EditPage /> },
    ],
  },
];
